/**
 * Route chunk loaders — kept separate from routes.js to avoid circular imports
 * (routes.js → MasterLayout → Header must not import back into routes.js).
 */
export const routeImports = {
  home: () => import('../components/home/HomePage'),
  tourDetails: () => import('../components/tour-details'),
  aboutUs: () => import('../components/about-us'),
  contactUs: () => import('../components/contact-us'),
  checkout: () => import('../components/checkout'),
  myProfile: () => import('../components/my-profile'),
  myBookings: () => import('../components/my-bookings'),
  myWishlist: () => import('../components/my-wishlist'),
  categories: () => import('../components/categories'),
  topPackages: () => import('../components/top-packages'),
  faq: () => import('../components/faq'),
  eventDetails: () => import('../components/event-details'),
  termsCondition: () => import('../components/terms-condition'),
};

/** Used by Header on hover — same loaders as lazy() routes */
export const prefetchRoute = routeImports;
